import Tenant from './tenant';
import Presence from './presence';
import UserLanguage from './userLanguage';
import User from './user';
import Login from './login';
import { appRoleSets, appRoleSetTypes } from 'services/Auth/appRoles';

export default class CurrentUser extends User {
  language: UserLanguage; //the current language of the user in the application

  presence: Presence;

  tenant: Tenant; //home tenant of the user (no org. unit)

  login: Login;

  constructor(id: string, tenant: Tenant, displayName: string, email: string, language: string) {
    super(id, email, displayName); //The Id of this CurrentUser is the Azure Tenant Id

    this.tenant = tenant;
    this.name = displayName;
    this.email = email;
    this.presence = new Presence('');
    this.language = new UserLanguage(language);
    this.login = new Login();
  }

  static getEmptyUser() {
    return new CurrentUser('', new Tenant('', ''), '', '', '');
  }

  clone(): CurrentUser {
    const newUser = new CurrentUser(this.id, this.tenant, this.name, this.email, this.language.code);
    newUser.created = this.created;
    newUser.lastLogin = this.lastLogin;
    newUser.hasLicense = this.hasLicense;
    newUser.photo = this.photo?.slice();
    newUser.photoURL = this.photoURL;
    newUser.presence = this.presence;
    newUser.login = this.login;
    newUser.language = this.language.clone();
    newUser.tenant = this.tenant.clone();

    return newUser;
  }

  override isAdmin = (): boolean => {
    const sr = this.login.userSystemRoles ?? [];

    for (let idx = 0; idx < sr.length; idx++) {
      if (appRoleSets[appRoleSetTypes.Admins].includes(sr[idx])) {
        return true;
      }
    }

    return false;
  };

  override hasPaidLicense = (): boolean => {
    const sr = this.login.userSystemRoles ?? [];

    for (let idx = 0; idx < sr.length; idx++) {
      if (appRoleSets[appRoleSetTypes.Licensed].includes(sr[idx])) {
        return true;
      }
    }

    return false;
  };

  getMyAccountURL() {
    return `https://myaccount.microsoft.com/`;
  }

  getMyAccountLanguageURL() {
    return `https://myaccount.microsoft.com/settingsandprivacy/language/`;
  }
}
